export default __webpack_public_path__ + "static/media/pizza.b68a2f5b.png";